import { Control, FieldValues, FieldPath } from 'react-hook-form';
import AsyncMultiSearchSelectRHF, {
  AsyncMultiSearchSelectProps,
} from '@/components/asyncSelect/AsyncMultiSearchSelectRHF.tsx';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import TourListDto from '@/features/dashboard/tours/types/TourListDto.ts';

type TourMultiSearchSelectProps<T extends FieldValues> = Omit<
  AsyncMultiSearchSelectProps<T, TourListDto>,
  'fetchFn' | 'toOption' | 'queryKey'
> & {
  fieldPathName: FieldPath<T>;
  control: Control<T>;
};

const TourMultiSearchSelectRHF = <T extends FieldValues>({
  ...props
}: TourMultiSearchSelectProps<T>) => {
  return (
    <AsyncMultiSearchSelectRHF<T, TourListDto>
      {...props}
      queryKey={toursApiQueryKeys.all()}
      fetchFn={toursApi.getTours}
      toOption={(item) => ({
        value: item.id,
        label: item.tourName,
      })}
    />
  );
};

export default TourMultiSearchSelectRHF;
